import { Helmet } from "react-helmet-async";
import { SITE_URL } from "@/lib/seo-jsonld";

const ORG_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "eBike & Co",
  url: SITE_URL,
  logo: `${SITE_URL}/favicon.avif`,
  description:
    "Location de vélos électriques et classiques dans les Landes — 8 points de location, livraison à domicile, assistance 7j/7.",
  telephone: "+33558427512",
  email: "info@e-bikeandco.com",
  areaServed: "Côte landaise, Landes, France",
  priceRange: "€€",
  sameAs: [
    "https://www.facebook.com/ebikeandco",
    "https://www.instagram.com/ebikeandco",
    // Google Business Profile — remplacer par l'URL `https://g.page/...` ou le lien Maps `?cid=` réel quand disponible
    "https://www.google.com/maps/search/?api=1&query=eBike+%26+Co+Saint-Julien-en-Born",
  ],
  address: {
    "@type": "PostalAddress",
    streetAddress: "208 Rte des Lacs",
    addressLocality: "Saint-Julien-en-Born",
    postalCode: "40170",
    addressRegion: "Nouvelle-Aquitaine",
    addressCountry: "FR",
  },
  contactPoint: {
    "@type": "ContactPoint",
    telephone: "+33558427512",
    contactType: "Réservations",
    areaServed: "FR",
    availableLanguage: ["French", "English"],
  },
};

/**
 * Organisation JSON-LD partagé.
 * Place ce composant au plus haut niveau de l'app (ex: App.tsx)
 * pour qu'il soit injecté sur **toutes** les pages.
 */
const OrganizationSchema = () => (
  <Helmet>
    <script type="application/ld+json">{JSON.stringify(ORG_SCHEMA)}</script>
  </Helmet>
);

export default OrganizationSchema;
